<!-- Tabs Header -->
<div class="card-header card-header-primary card-nav-tabs  rounded-lg mt-2">
    <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
            <ul class="nav nav-tabs" role="tablist">
                <li class="border rounded-lg me-2 nav-item"
                    v-for="(status, index) in main_stages"
                    :key="status.id"
                    :class="{ active: active_status_tab === index, inactive: active_status_tab !== index }">
                    <a class="text-white text-decoration-none nav-link text-xs"
                        @click="change_status_tab(index)">
                        {{ status.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="card border-0 p-2 shadow-sm mt-3">


    <div class="card-body">
        <!-- Tab Content - main statuses -->
        <div v-for="(status, index) in main_stages" :key="'content-'+status.id" v-show="active_status_tab === index">
            <div class="bg-light p-2 rounded mb-4 shadow">
                <div class="d-flex align-items-center">
                    <label for="select_main_status" class="form-label text-xxs mb-0 me-2">I'm working with:</label>
                    <select
                        id="select_main_status"
                        class="form-select form-select-sm text-xxs rounded-3 shadow-sm w-auto flex-shrink-0"
                        v-model="selected_stage">
                        <option disabled hidden value="">Select a status</option>
                        <option v-for="option in sub_status_options" :key="option.value" :value="option.value">
                            {{ option.label }}
                        </option>
                    </select>
                </div>
            </div>

            <p class="mb-4 text-xxs">For each sub-stage, select where an enquiry can move next:</p>


            <div class="border table-border-color rounded-lg p-4">
                 <div class="d-flex rounded-top p-2 font-weight-bold custom-header">
                    <div class="text-center text-white text-xxs flex-shrink-0 w-25">Sub-Status</div>
                    <div class="flex-grow-1 text-center text-white text-xxs">Can Move To</div>
                </div>
                <!-- Dynamic Rules -->
                <div v-for="stage in filtered_stages" :key="stage" class="d-flex align-items-center border p-3">
                    <div class="text-center text-xxs flex-shrink-0 w-25">{{ stage }}</div>
                    <div class="flex-grow-1 d-flex align-items-center">
                    <div class="mr-2 me-2">→ </div>
                    <div class="flex-grow-1">
                        <div v-if="get_current_rules(main_stages[active_status_tab].name)[stage]?.length">
                        <div v-for="rule in get_current_rules(main_stages[active_status_tab].name)[stage]"
                            :key="rule.name"
                            class="d-flex align-items-center mb-2">
                            <span class="badge bg-primary-light text-dark me-2 text-xxs">
                            {{ rule.name }}
                            </span>
                            <span class="text-muted text-xxs">({{ rule.expression }})</span>
                        </div>
                        </div>
                        <div v-else class="text-muted text-xxs">
                        No rules defined
                        </div>
                    </div>
                    <button class="btn btn-sm btn-primary-dark text-xxs ms-2 ml-2 shadow"
                            data-bs-toggle="modal"
                            data-bs-target="#create_rule_modal"
                            @click="open_rule_modal(stage)">
                        Add Rule
                    </button>
                    </div>
                </div>
                <div class="mt-4">
                <button class="btn btn-sm btn-primary-dark text-xxs ms-2 ml-2 shadow" @click="save_changes">
                    Save Changes
                </button>
            </div>
            </div>
        </div>
    </div>
</div>

<!-- Create rule Modal -->
 <teleport to="body">
<div class="modal fade" id="create_rule_modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
            <div class="modal-header border-bottom-0 cute-header shadow-lg">
                <h5 class="modal-title text-white text-xxs">Add Transition Rule for "{{ current_editing_stage }}"</h5>
                <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="mb-3">
                    <label for="select_rule" class="form-label text-xxs">
                        Choose a transition rule
                    </label>
                    <select
                        id="select_rule"
                        class="form-select form-select-sm text-xxs"
                        v-model="new_rule.selected_rule_id"
                    >
                        <option disabled value="">-- pick a rule --</option>
                        <option
                        v-for="r in available_rules"
                        :key="r.id"
                        :value="r.id"
                        >
                        {{ r.name }} ({{ r.expression }})
                        </option>
                    </select>
                </div>
                <div class="mb-3">
                    <label for="select_type" class="form-label text-xxs">
                        Choose a transition type
                    </label>
                    <select id="select_type" class="form-select form-select-sm text-xxs" v-model="new_rule.selected_transition_type_id">
                        <option disabled value="">-- pick a type --</option>
                        <option v-for="t in available_types" :key="t.id" :value="t.id">
                            {{ t.type }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow" @click="save_rule">Save Rule</button>
            </div>
        </div>
    </div>
</div>
</teleport>